import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { Icon } from '../../KeyComponents';
import Button from '../../Button';

function Streak({ data }) {
  const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const startOfWeek = new Date(today);
  const currentDay = today.getDay();
  const mondayOffset = currentDay === 0 ? -6 : 1 - currentDay;
  startOfWeek.setDate(today.getDate() + mondayOffset);

  const currentWeekChecks = daysOfWeek.map((_, index) => {
    const checkDate = new Date(startOfWeek);
    checkDate.setDate(startOfWeek.getDate() + index);

    return data?.attendance?.find((item) => {
      const date = new Date(item.createdAt).toLocaleDateString();
      return date === checkDate.toLocaleDateString();
    });
  });

  const currentStreak = data?.currentStreak;
  const bestStreak = data?.bestStreak;

  return (
    <div className="streak">
      <div className="streak__header">
        Streak
      </div>
      <div className="streak__content">
        {currentWeekChecks.map((check, index) => (
          <div className="streak__content__item">
            {daysOfWeek[index]}
            <div className="streak__content__item__icon">
              <Icon icon="flashlight" type={check ? 'fill' : 'line'} size="md" variant={check ? 'primary' : 'subtle'} />
            </div>
          </div>
        ))}
      </div>
      <div className="streak__footer">
        <div className="streak__footer__left">
          <div className="streak__footer__left__title">
            Current Streak
          </div>
          <div className="streak__footer__left__value h5">
            {currentStreak} days
          </div>
        </div>
        <div className="streak__footer__right">
          <div className="streak__footer__right__title">
            Your Best
          </div>
          <div className="streak__footer__right__value h5">
            {bestStreak} days
          </div>
        </div>
      </div>
    </div>
  );
}

Streak.propTypes = {
  data: PropTypes.object
}

Streak.defaultProps = {
  data: {
    attendance: [],
    currentStreak: 0,
    bestStreak: 0
  }
}

function StreakDropdown({ data }) {
  const currentStreak = data?.currentStreak;
  return (
    <Dropdown className="streak-dropdown">
      <Dropdown.Toggle as={Button} variant="ghost-gray" iconBefore="flashlight" className="streak-button">
        {currentStreak}d
      </Dropdown.Toggle>
      <div className="streak-menu-wrapper">
        <Dropdown.Menu className="streak-menu">
          <Streak data={data} />
        </Dropdown.Menu>
      </div>
    </Dropdown>
  );
}

StreakDropdown.propTypes = {
  data: PropTypes.object
}

StreakDropdown.defaultProps = {
  data: {
    attendance: [],
    currentStreak: 0,
    bestStreak: 0
  }
}


export default Streak;
export { StreakDropdown };
